import {
  afterDotLetterToLowercase,
  firstLetterToLowercase,
} from './textHelpers';

export const preparePathFromResponse = (path: string) => {
  const result = afterDotLetterToLowercase(firstLetterToLowercase(path));
  return result;
};
